import React, { useState } from "react";
import { getAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { API_ADMIN_LIO_INSPECTOR_TRANSELEC, API_ADMIN_LIO_PREVENCIONISTA, ROW_COUNT, ROW_COUNT_MAX, URL_SUPPORT } from "../../helpers/variableHelper";
import { dateFormatInputReference } from "../../helpers/dateHelper";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { IPagination } from "../../controls/AdminListaPagination";
import { Col, Row } from "react-bootstrap";
import LIOService from "../../services/LIOService";
import IInspeccionObservacion from "../../entities/IInspeccionObservacion";
import UserPickerData from "../../controls/UserPickerData";
import ILIOInspectorTranselec from "../../entities/ILIOInspectorTranselec";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import Loading from "../../cross/Loading";
import ICurrentUser from "../../entities/helper/ICurrentUser";
const MySwal = withReactContent(Swal);

interface ILIOMantenedorProps {
    busquedaLIO?: IInspeccionObservacion;
}

export default function LIOMantenedor({ busquedaLIO }: ILIOMantenedorProps) {
    const [token, setToken] = useState("");
    const [currentUser, setCurrentUser] = useState<ICurrentUser>();
    const [isLoading, setIsLoading] = useState(true);
    const refNroInspeccion = React.createRef<HTMLInputElement>();
    const refFechaDeteccion = React.createRef<HTMLInputElement>();
    const refInstalacionIntervenir = React.createRef<HTMLInputElement>();
    const refATN = React.createRef<HTMLInputElement>();
    const refJefeFaena = React.createRef<HTMLInputElement>();
    const refObservaciones = React.createRef<HTMLTextAreaElement>();
    const [lioBusqueda, setLioBusqueda] = useState<IInspeccionObservacion | null>(busquedaLIO || null);
    const [busquedaInicial, setBusquedaInicial] = useState(false);
    const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
    const [listInspeccionadoPor, setListInspeccionadoPor] = useState<Array<ILIOInspectorTranselec>>([]);
    const [inspeccionadoPorSeleccionado, setInspeccionadoPorSeleccionado] = useState<Array<IUserPickerValue>>([]);
    const [isSendingData, setIsSendingData] = useState(false);
    const [isExternoInspector, setIsExternoInspector] = useState(false);
    console.log(isLoading);
    console.log(busquedaInicial);
    usePromiseEffect(async () => {
        setIsLoading(true);
        let token = await cognitoUserToken();
        setToken(token);
        let currUser = await cognitoUserInfo();
        setCurrentUser(currUser);
        try {
            if (currUser.external && currUser?.roles.IS_EXT_LIO) {
                let params = {
                    PAGINA: 1,
                    PAGINADO: ROW_COUNT,
                    ORDENADOPOR: "ID",
                    ORIENTACION: "DESC",
                    TITULO: null,
                    NOMBRE_INSPECTOR_CONTRATISTA: currUser.email,
                    ID_GERENCIA_SUBGERENCIA: null,
                    ACTIVO: null,
                };
                let result = (
                    await getAPI(
                        `${URL_SUPPORT}${API_ADMIN_LIO_PREVENCIONISTA}/GetAllEmpresaInspectora`,
                        { Authorization: `Bearer ${token}` },
                        params
                    )
                ).result.data;
                setIsExternoInspector(result.length > 0);
            }
        } catch (error) {}
    }, []);

    const fillInspeccionadoPor = async (gerenciaTitle?: string) => {
        let paramsActive = {
            PAGINA: 1,
            PAGINADO: ROW_COUNT_MAX,
            ORDENADOPOR: "ID",
            ORIENTACION: "ASC",
            NOMBRE_GERENCIA: gerenciaTitle,
            ACTIVO: true,
        };
        const inspeccionadoPor: Array<ILIOInspectorTranselec> = (
            await getAPI(`${URL_SUPPORT}${API_ADMIN_LIO_INSPECTOR_TRANSELEC}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
        ).result.data;
        setListInspeccionadoPor(inspeccionadoPor);
    };

    const handleValidacionBusqueda = () => {
        let arrErrors = [];
        if (!refNroInspeccion.current?.value || isNaN(parseInt(refNroInspeccion.current?.value || ""))) {
            arrErrors.push("Ingrese un código correcto");
        }
        if (arrErrors.length > 0) {
            MySwal.fire({
                html: (
                    <div>
                        <h3>Favor seleccione lo siguiente:</h3>
                        {arrErrors.map((e) => (
                            <p key={e}>{e}</p> //   
                        ))}
                    </div>
                ),
                icon: "warning",
                confirmButtonText: "Aceptar",
                showCloseButton: true,
                showCancelButton: false,
            });

            return false;
        }
        return true;
    };
    const handleBuscar = async (pagination?: IPagination) => {
        if (handleValidacionBusqueda()) {
            let result = await LIOService.getLIOByID(token, parseInt(refNroInspeccion.current?.value as string));
            if (result?.ID) {
                fillInspeccionadoPor(result?.GERENCIA_SUBGERENCIA);
                setLioBusqueda(result);
                setInspeccionadoPorSeleccionado([{ name: result?.INSPECTOR_FAENA_DISPLAY, mail: result?.INSPECTOR_FAENA }]);
                setBusquedaInicial(true);
            } else {
                setLioBusqueda(null);
                setInspeccionadoPorSeleccionado([]);
                setBusquedaInicial(false);
            }
        }
    };

    const formValidation = (value: Partial<IInspeccionObservacion>) => {
        let arrErrors: Array<string> = [];

        if (!moment(value.FECHA_DETECCION).isValid()) {
            arrErrors.push("FECHA_DETECCION");
        } else if (moment(value.FECHA_DETECCION) > moment()) {
            arrErrors.push("FECHA_DETECCION");
            MySwal.fire({
                title: <p>Fecha detección inválida, no puede ser mayor a la fecha actual</p>,
                icon: "error",
            });
        }

        if (!value.INSPECTOR_FAENA || !value.INSPECTOR_FAENA_DISPLAY) {
            arrErrors.push("INSPECTOR_FAENA");
        }

        setArrErrorEmpty(arrErrors);
        return arrErrors.length === 0;
    };

    const handleGuardarLIO = async (enviarLIO?: boolean) => {
        let value: Partial<IInspeccionObservacion> = {
            ...lioBusqueda,
            FECHA_DETECCION: new Date(refFechaDeteccion.current?.value || ""),
            INSTALACION_INTERVENIR: refInstalacionIntervenir.current?.value as string,
            ATN: refATN.current?.value as string,
            JEFE_FAENA_SUPERVISOR: refJefeFaena.current?.value as string,
            INSPECTOR_FAENA: inspeccionadoPorSeleccionado[0]?.mail,
            INSPECTOR_FAENA_DISPLAY: inspeccionadoPorSeleccionado[0]?.name,
            OBSERVACIONES: refObservaciones.current?.value as string,
        };

        if (formValidation(value)) {
            setIsSendingData(true);
            let id = await LIOService.ingresoLIO(token, value);
            setLioBusqueda(value as IInspeccionObservacion);
            setIsSendingData(false);
            MySwal.fire({
                title: <p>Lio modificado con exito</p>,
                icon: "success",
            });
            return id;
        } else {
            MySwal.fire({
                title: <p>Complete todos los campos requeridos</p>,
                icon: "error",
            });
            return -1;
        }
    };

    const handleLimpiarCampos = () => {
        (refNroInspeccion.current as HTMLInputElement).value = "";
    };

    return (
        <div className="row">
            <div className="col-12">
                <div className="rounded bg-white p-2 shadow">
                    <div className="container-fluid mb-4">
                        <h1 className="titPrincipal colorTit">Mantenedor de LIO (Por Código)</h1>
                        <div className="alert alert-warning p-1 mb-2" role="alert">
                            <i className="text-info bi bi-info-circle-fill me-2"></i>
                            <small>
                                <strong>Nota:</strong> Nota: Esta Pantalla permite consultar Inspecciones/Observaciones y realizar cambios en su forma
                                básica.
                            </small>
                        </div>
                        <div className="row ajusteInput">
                            <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                <label className="text-sm">Número de Inspección (ejemplo 350,351):</label>
                                <input className="form-control form-control-sm" type="text" placeholder="Indique el número" ref={refNroInspeccion} />
                            </div>
                            <div className="mt-1">
                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary me-2"
                                    onClick={() => {
                                        handleBuscar();
                                    }}>
                                    {" "}
                                    <i className="bi bi-search me-2"></i> Buscar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary me-2"
                                    onClick={() => {
                                        handleLimpiarCampos();
                                    }}>
                                    {" "}
                                    <i className="bi bi-trash me-2"></i>Limpiar
                                </button>
                            </div>
                        </div>
                        {lioBusqueda && (
                            <div className="card bg-light border p-3 pt-2 mt-2">
                                <h1 className="titPrincipal colorTit">Datos de Ingresos</h1>
                                <div className="row ajusteInput">
                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                        <Col xs="12" md="6" lg="4">
                                            <label>Número de Inspección:</label>
                                        </Col>
                                        <Col xs="12" md="6" lg="8">
                                            <p>{lioBusqueda?.CORRELATIVO}</p>
                                        </Col>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                        <Col xs="12" md="6" lg="4">
                                            <label>Vicepresidencia:</label>
                                        </Col>
                                        <Col xs="12" md="6" lg="8">
                                            <p>{lioBusqueda?.VICEPRESIDENCIA}</p>
                                        </Col>
                                    </div>

                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                        <Col xs="12" md="6" lg="4">
                                            <label>Gerencia/Subgerencia:</label>
                                        </Col>
                                        <Col xs="12" md="6" lg="8">
                                            <p>{lioBusqueda?.GERENCIA_SUBGERENCIA}</p>
                                        </Col>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                        <Col xs="12" md="6" lg="4">
                                            <label>Unidad Proyecto:</label>
                                        </Col>
                                        <Col xs="12" md="6" lg="8">
                                            <p>{lioBusqueda?.UNIDAD_PROYECTO}</p>
                                        </Col>
                                    </div>
                                    <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                                        <Col xs="12" md="6" lg="4">
                                            <label>Contratistas/SubContratistas:</label>
                                        </Col>
                                        <Col xs="12" md="6" lg="8">
                                            <p>{lioBusqueda?.CONTRATISTA_SUBCONTRATISTA}</p>
                                        </Col>
                                    </div>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Fecha Detección</label>
                                            <div className="d-flex">
                                                <input
                                                    className={`${
                                                        arrErrorEmpty.includes("FECHA_DETECCION") && "error"
                                                    } form-control form-control-sm me-2`}
                                                    type="date"
                                                    placeholder="Desde"
                                                    ref={refFechaDeteccion}
                                                    defaultValue={moment(lioBusqueda?.FECHA_DETECCION).format(dateFormatInputReference)}
                                                    max={moment().format(dateFormatInputReference)}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Instalación a intervenir</label>
                                            <div className="d-flex">
                                                <input
                                                    className={`${
                                                        arrErrorEmpty.includes("INSTALACION_INTERVENIR") && "error"
                                                    } form-control form-control-sm me-2`}
                                                    type="text"
                                                    placeholder="Instalación a intervenir"
                                                    ref={refInstalacionIntervenir}
                                                    defaultValue={lioBusqueda?.INSTALACION_INTERVENIR}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">AT N°</label>
                                            <div className="d-flex">
                                                <input
                                                    className={`${arrErrorEmpty.includes("ATN") && "error"} form-control form-control-sm me-2`}
                                                    type="text"
                                                    placeholder="AT N°"
                                                    ref={refATN}
                                                    defaultValue={lioBusqueda?.ATN}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Jefe Faena o Supervisor</label>
                                            <div className="d-flex">
                                                <input
                                                    className={`${
                                                        arrErrorEmpty.includes("JEFE_FAENA_SUPERVISOR") && "error"
                                                    } form-control form-control-sm me-2`}
                                                    type="text"
                                                    placeholder="Jefe Faena o Supervisor"
                                                    ref={refJefeFaena}
                                                    defaultValue={lioBusqueda?.JEFE_FAENA_SUPERVISOR}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <span className="text-danger">
                                                <strong>(*)</strong>
                                            </span>
                                            <label className="text-sm">Inspeccionado por</label>
                                            <div className="d-flex">
                                                <UserPickerData
                                                    name={"Inspeccionado por"}
                                                    callback={(ip, val) => {
                                                        setInspeccionadoPorSeleccionado(val);
                                                    }}
                                                    id={"inspeccionadoPor"}
                                                    key={"1"}
                                                    multi={false}
                                                    disabled={false}
                                                    className={`${arrErrorEmpty.includes("INSPECTOR_FAENA") && "error"} borderColorGris`}
                                                    defaultValue={inspeccionadoPorSeleccionado || []}
                                                    options={listInspeccionadoPor.map((ip) => {
                                                        return {
                                                            mail: ip.USUARIO,
                                                            name: ip.USUARIO_DISPLAY,
                                                        };
                                                    })}
                                                    currentUser={currentUser}
                                                    isExternoInspector={isExternoInspector}
                                                />
                                            </div>
                                        </Col>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Tipo de Faena</label>
                                            <div className="d-flex">
                                                <p>{lioBusqueda?.TIPO_FAENA}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Faena</label>
                                            <div className="d-flex">
                                                <p>{lioBusqueda?.HORARIO}</p>
                                            </div>
                                        </Col>
                                        <Col xs="12" md="6" lg="6">
                                            <label className="text-sm">Observaciones</label>
                                            <div className="d-flex">
                                                <textarea
                                                    className={`${
                                                        arrErrorEmpty.includes("OBSERVACIONES") && "error"
                                                    } form-control form-control-sm me-2`}
                                                    ref={refObservaciones}
                                                    defaultValue={lioBusqueda?.OBSERVACIONES}
                                                />
                                            </div>
                                        </Col>
                                    </Row>

                                    <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                                        {isSendingData ? (
                                            <Loading />
                                        ) : (
                                            <span>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary me-2"
                                                    onClick={() => {
                                                        handleGuardarLIO();
                                                    }}>
                                                    Guardar
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary me-2"
                                                    onClick={() => {
                                                        window.location.href = "/LIO";
                                                    }}>
                                                    Cancelar
                                                </button>
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
